export enum LocalhostKeys {
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  USER_INFO = 'USER_INFO',
  LANGUAGE = 'LANGUAGE',
  GOOGLE_MAP_KEY = 'GOOGLE_MAP_KEY',
  PERMISSIONS = 'PERMISSIONS',
}
